const NewTaskIcon = (): JSX.Element => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.74998 11.1113V6.84462C6.74998 5.84897 6.74998 5.35077 6.94071 4.97049C7.10849 4.63598 7.37601 4.36421 7.70529 4.19377C8.07963 4 8.57004 4 9.55012 4H13.4653C13.5725 4 13.6663 4 13.7499 4.00077M18.999 9.33333C18.9998 9.41832 18.9998 9.51374 18.9998 9.62283V17.1587C18.9998 18.1524 18.9998 18.6493 18.8093 19.0292C18.6415 19.3637 18.3733 19.636 18.044 19.8064C17.67 20 17.1807 20 16.2025 20L12.8749 20M18.999 9.33333C18.9966 9.07956 18.9873 8.91889 18.9511 8.76562C18.9083 8.58423 18.8373 8.41079 18.7413 8.25173C18.6331 8.07232 18.4826 7.91901 18.1799 7.61154L15.4452 4.83333C15.1427 4.52606 14.9911 4.37206 14.8146 4.26215C14.658 4.16468 14.4874 4.09267 14.3089 4.04912C14.1579 4.01231 13.9998 4.00308 13.7499 4.00077M18.999 9.33333H19M18.999 9.33333H16.5472C15.569 9.33333 15.0792 9.33333 14.7052 9.13976C14.3759 8.96931 14.1084 8.69681 13.9406 8.3623C13.7499 7.98201 13.7499 7.48454 13.7499 6.48889V4.00077M9.37495 13.7778L11.1249 15.5556M5 20V17.7778L11.5624 11.1111L13.7499 13.3333L7.18747 20H5Z"
      stroke="#447AED"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default NewTaskIcon;
